import * as types from '../types/index'
import axios from 'axios'
import toast from 'react-hot-toast'
import config from '../config'
import { authHeader, header } from '../headers'
import { admin_logout } from './adminAuthActions'

const url = config.testUrl

export const user_register = (user) => async (dispatch) => {
	try {
		dispatch({ type: types.USER_REGISTER_REQUEST })

		const { data } = await axios.post(`${url}/users`, user, {
			headers: header,
		})

		if (data.status === 'ok') {
			dispatch({
				type: types.USER_REGISTER_SUCCESS,
				payload: data,
			})
			toast.success('User Created Successfully!', {
				position: 'top-right',
			})
		}
	} catch (error) {
		const message = error.response
			? error.response.data.message
			: 'Something went wrong'
		if (message === 'Access Not Authorized' || message === 'Not Authorized') {
			dispatch(user_logout())
		}
		dispatch({ type: types.USER_REGISTER_FAIL, payload: message })
		toast.error(message, { position: 'top-right' })
	}
}

export const user_login = (inputText, password) => async (dispatch) => {
	try {
		dispatch({ type: types.USER_AUTH_REQUEST })

		const { data } = await axios.post(
			`${url}/users/login`,
			{ inputText, password },
			{ headers: header }
		)

		if (data.status === 'ok') {
			dispatch({ type: types.USER_AUTH_SUCCESS, payload: data.data })
			toast.success(`You are welcome, ${data.data.firstName}`, {
				position: 'top-right',
			})
		}
	} catch (error) {
		const message = error.response
			? error.response.data.message
			: 'Something went wrong'
		if (message === 'Access Not Authorized' || message === 'Not Authorized') {
			dispatch(user_logout())
		}
		dispatch({ type: types.USER_AUTH_FAIL, payload: message })
		toast.error(message, { position: 'top-right' })
	}
}

export const user_verify_email = (id, tokenId) => async (dispatch) => {
	try {
		dispatch({ type: types.USER_VERIFY_EMAIL_REQUEST })

		const { data } = await axios.put(
			`${url}/users/email/verify/${id}/${tokenId}`,
			{
				headers: header,
			}
		)

		if (data.status === 'ok') {
			dispatch({ type: types.USER_VERIFY_EMAIL_SUCCESS, payload: data.data })
		}
	} catch (error) {
		const message = error.response
			? error.response.data.message
			: 'Something went wrong'
		if (message === 'Access Not Authorized' || message === 'Not Authorized') {
			dispatch(user_logout())
		}
		dispatch({ type: types.USER_VERIFY_EMAIL_FAIL, payload: message })
		// toast.error(message, { position: 'top-right' })
	}
}

export const get_user_profile = (id) => async (dispatch, getState) => {
	try {
		dispatch({ type: types.GET_USER_PROFILE_REQUEST })

		const {
			userAuth: { userDetail },
		} = getState()

		const { data } = await axios.get(`${url}/users/${id}`, {
			headers: authHeader(userDetail.token),
		})

		if (data.status === 'ok') {
			dispatch({
				type: types.GET_USER_PROFILE_SUCCESS,
				payload: data.data,
			})
		}
	} catch (error) {
		const message = error.response
			? error.response.data.message
			: 'Something went wrong'
		if (message === 'Access Not Authorized' || message === 'Not Authorized') {
			dispatch(user_logout())
		}
		dispatch({ type: types.GET_USER_PROFILE_FAIL, payload: message })
		toast.error(message, { position: 'top-right' })
	}
}

export const refresh_user_profile = (id) => async (dispatch, getState) => {
	try {
		dispatch({ type: types.GET_USER_PROFILE_REQUEST })

		const {
			userAuth: { userDetail },
		} = getState()

		const { data } = await axios.get(`${url}/users/${id}`, {
			headers: authHeader(userDetail.token),
		})

		if (data.status === 'ok') {
			dispatch({
				type: types.GET_USER_PROFILE_SUCCESS,
				payload: data.data,
			})

			let passedData = {
				...data.data,
				token: userDetail.token,
				id: userDetail.id,
			}
			dispatch({
				type: types.USER_AUTH_SUCCESS,
				payload: passedData,
			})
		}
	} catch (error) {
		const message = error.response
			? error.response.data.message
			: 'Something went wrong'
		if (message === 'Access Not Authorized' || message === 'Not Authorized') {
			dispatch(user_logout())
		}
		dispatch({ type: types.GET_USER_PROFILE_FAIL, payload: message })
		toast.error(message, { position: 'top-right' })
	}
}

export const update_user_profile = (id, user) => async (dispatch, getState) => {
	try {
		dispatch({ type: types.UPDATE_USER_PROFILE_REQUEST })

		const {
			userAuth: { userDetail },
		} = getState()

		const { data } = await axios.patch(`${url}/users/${id}`, user, {
			headers: authHeader(userDetail.token),
		})

		if (data.status === 'ok') {
			dispatch({
				type: types.UPDATE_USER_PROFILE_SUCCESS,
				payload: data.data,
			})
			dispatch(refresh_user_profile(data.data.fullName))
			toast.success('Your account has been updated!', {
				position: 'top-right',
			})
		}
	} catch (error) {
		const message = error.response
			? error.response.data.message
			: 'Something went wrong'
		if (message === 'Access Not Authorized' || message === 'Not Authorized') {
			dispatch(user_logout())
		}
		dispatch({ type: types.UPDATE_USER_PROFILE_FAIL, payload: message })
		toast.error(message, { position: 'top-right' })
	}
}

export const user_logout = () => (dispatch) => {
	dispatch({ type: types.USER_AUTH_LOGOUT })
	document.location.href = '/'
}

export const get_all_users = (page) => async (dispatch, getState) => {
	try {
		dispatch({ type: types.GET_ALL_USERS_REQUEST })

		const {
			adminAuth: { detail },
		} = getState()

		let link = `${url}/users/all?pageNumber=${page}`

		const { data } = await axios.get(link, {
			headers: authHeader(detail.token),
		})

		if (data.status === 'ok') {
			dispatch({
				type: types.GET_ALL_USERS_SUCCESS,
				payload: data.data,
			})
		}
	} catch (error) {
		const message = error.response
			? error.response.data.message
			: 'Something went wrong'
		if (message === 'Access Not Authorized' || message === 'Not Authorized') {
			dispatch(admin_logout())
		}
		dispatch({ type: types.GET_ALL_USERS_FAIL, payload: message })
		toast.error(message, { position: 'top-right' })
	}
}

export const get_user_details = (slug) => async (dispatch, getState) => {
	try {
		dispatch({ type: types.GET_USER_DETAILS_REQUEST })

		const {
			adminAuth: { detail },
		} = getState()

		const { data } = await axios.get(`${url}/users/${slug}`, {
			headers: authHeader(detail.token),
		})

		if (data.status === 'ok') {
			dispatch({
				type: types.GET_USER_DETAILS_SUCCESS,
				payload: data.data,
			})
		}
	} catch (error) {
		const message = error.response
			? error.response.data.message
			: 'Something went wrong'
		if (message === 'Access Not Authorized' || message === 'Not Authorized') {
			dispatch(user_logout())
		}
		dispatch({ type: types.GET_USER_DETAILS_FAIL, payload: message })
		toast.error(message, { position: 'top-right' })
	}
}
